import { render, staticRenderFns } from "./PaymentGateway.vue?vue&type=template&id=2f97d7c1&scoped=true"
import script from "./PaymentGateway.vue?vue&type=script&lang=js"
export * from "./PaymentGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97d7c1",
  null
  
)

export default component.exports